import { render, staticRenderFns, recyclableRender, components } from "./payment-record.vue?vue&type=template&id=2469826d&scoped=true&"
var renderjs
import script from "./payment-record.vue?vue&type=script&lang=js&"
export * from "./payment-record.vue?vue&type=script&lang=js&"
import style0 from "./payment-record.vue?vue&type=style&index=0&id=2469826d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2469826d",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/account/payment-record.vue"
export default component.exports